export const stockReportColumn = [
    {
        Header: 'Product Name',
        accessor: 'productName',
    },
    {
        Header: 'Quantity',
        accessor: 'quantity',
    },
    {
        Header: 'Price',
        accessor: 'price',
    },
    {
        Header: 'Amount',
        accessor: 'amount',
    }
]

export const stockReportTableData = [
    {
        "productName": "Bath Towel",
        "quantity": "300",
        "price": "$5",
        "amount": "$1500",
    },
    {
        "productName": "Bathrobe",
        "quantity": "20",
        "price": "$30",
        "amount": "$600",
    },
    {
        "productName": "Bed Cover",
        "quantity": "30",
        "price": "$20",
        "amount": "$600",
    },
    {
        "productName": "Chair",
        "quantity": "30",
        "price": "$50",
        "amount": "$1500",
    },
    {
        "productName": "Conditioner",
        "quantity": "40",
        "price": "$6",
        "amount": "$240",
    },
    {
        "productName": "Hand Soap",
        "quantity": "200",
        "price": "$2",
        "amount": "$400",
    },
    {
        "productName": "Pillowcase Set",
        "quantity": "50",
        "price": "$10",
        "amount": "$500",
    },
    {
        "productName": "Shampoo",
        "quantity": "60",
        "price": "$7",
        "amount": "$420",
    },
    {
        "productName": "Shower Gel",
        "quantity": "80",
        "price": "$8",
        "amount": "$640",
    },
    {
        "productName": "Toothbrush",
        "quantity": "150",
        "price": "$2",
        "amount": "$300",
    },
    {
        "productName": "Toothpaste",
        "quantity": "120",
        "price": "$3",
        "amount": "$360",
    },
]